import React from 'react'
import { ReactComponent as AfricaArabia } from './icons/AfricaArabia.svg';
import { ReactComponent as Asia } from './icons/Asia.svg';
import { ReactComponent as Caribbean } from './icons/Caribbean.svg';
import { ReactComponent as CentralAmerica } from './icons/CentralAmerica.svg';
import { ReactComponent as Hawaii } from './icons/Hawaii.svg';
import { ReactComponent as SouthAmerica } from './icons/SouthAmerica.svg';
import { ReactComponent as CoffeeBean } from './icons/CoffeeBean.svg';

function Icons(props) {
    const components = {
        africaArabia: AfricaArabia,
        asiaPacific: Asia,
        caribbean: Caribbean,
        centralAmerica: CentralAmerica,
        hawaii: Hawaii,
        southAmerica: SouthAmerica,
        CoffeeBean: CoffeeBean,
        };
    const IconName = components[props.name];
    
    return (
            <IconName height={props.size} width={props.size} fill={props.color}  />           
        
    )
}

export default Icons
